import { render, staticRenderFns } from "./right-fixedgt.vue?vue&type=template&id=1ef212e8&scoped=true&"
import script from "./right-fixedgt.vue?vue&type=script&lang=js&"
export * from "./right-fixedgt.vue?vue&type=script&lang=js&"
import style0 from "./right-fixedgt.vue?vue&type=style&index=0&id=1ef212e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef212e8",
  null
  
)

export default component.exports